import { render, staticRenderFns } from "./PatRecordAPage.vue?vue&type=template&id=04bc1c02"
import script from "./PatRecordAPage.vue?vue&type=script&lang=js"
export * from "./PatRecordAPage.vue?vue&type=script&lang=js"
import style0 from "./PatRecordAPage.vue?vue&type=style&index=0&id=04bc1c02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports